import { Colors, Durations, Easing, Font } from "@ptml/design-system";
import styled, { keyframes } from "styled-components";

export const Container = styled.div`
    width: fit-content;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr auto;
    padding: 3.5rem 2rem;
    column-gap: 2rem;
    row-gap: 1rem;

    pre {
        max-width: 85ch;
        white-space: pre-wrap;
        font-family: "Courier New", Courier, monospace;
    }
`;

const slideDownAndFade = keyframes`
  0% { opacity: 0; transform: translateY(-10%); }
    100% { opacity: 1; transform: translateY(0); }
`;

const fadeIn = keyframes`
  0% { opacity: 0;  }
    100% { opacity: 1;  }
`;

export const Supertitle = styled.span`
    font-size: 20px;
    color: ${Colors.Blue70};
    animation-name: ${slideDownAndFade};
    animation-duration: ${Durations.short150}ms;
    animation-timing-function: ${Easing.standard.css};
    animation-delay: 200ms;
    animation-fill-mode: backwards;
`;

export const Title = styled.h1`
    font-weight: ${Font.weight.bold};
    font-size: 4.5rem;
    line-height: 5.5rem;
    letter-spacing: -1px;
    grid-column-start: 1;
    color: ${Colors.Grey900};
    animation-name: ${slideDownAndFade};
    animation-duration: ${Durations.medium250}ms;
    animation-timing-function: ${Easing.standard.css};
    animation-delay: 120ms;
    animation-fill-mode: backwards;
`;

export const ImageContainer = styled.figure`
    grid-area: img;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    animation-name: ${fadeIn};
    animation-duration: ${Durations.medium400}ms;
    animation-timing-function: ${Easing.standard.css};
    animation-delay: 120ms;
    animation-fill-mode: backwards;
`;
